<template>
    <div>
        <DateSwitch v-if="dateSwitch" v-model="date" :allowed-max-date="moment().add(3, 'weeks')" />

        <ul class="helper-legend">
            <li class="legend-slot lightgrey">
                <span>{{ __('Unavailable slot') }}</span>
            </li>
            <li class="legend-slot grey">
                <span>{{ __('Workload up to 49%') }}</span>
            </li>
            <li class="legend-slot orange">
                <span>{{ __('Workload over 50%') }}</span>
            </li>
            <li class="legend-slot red">
                <span>{{ __('Occupied slot') }}</span>
            </li>
        </ul>

        <div v-if="!loading" class="workload-slotlist">
            <div
                v-for="[slotDate, slots] in workloadCalendarData"
                :key="slotDate"
                class="workload-daywrapper"
                :data-weekday="moment(slotDate).day()"
                :data-week="moment(slotDate).week() === date.week() ? '1' : '2'"
            >
                <span :class="{ today: moment(slotDate).format('YYYY-MM-DD') === moment().format('YYYY-MM-DD') }">
                    {{ moment(slotDate).format('dd D. M.') }}
                </span>
                <div class="workload-daylist" :style="{ opacity: slots.has_data ? 1 : 0.1 }">
                    <div
                        v-for="[slot, slotData] in Object.entries(slots.data)"
                        :key="slot"
                        class="workload-day tooltip"
                        :class="`${usage(slotData)}`"
                        :data-index="slot"
                    >
                        <div v-if="usage(slotData) !== ''" class="tooltip-content">
                            <span class="tooltip-datetime">
                                {{ moment(slotDate).format('dddd D. M.') }} {{ calculateTime(slot) }}
                            </span>
                            <span class="tooltip-slot" v-html="usageTooltip({ slotDate, slot, ...slotData })"></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="workload-slotlist">
            <div slot="spinner" class="loader-wrapper">
                <img src="imgs/vitadio-loader.svg" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import DateSwitch from './DateSwitch.vue'

export default {
    components: {
        DateSwitch
    },
    props: {
        dateSwitch: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            data: {},
            date: moment(),
            loading: false
        }
    },
    computed: {
        workloadCalendarData() {
            const data = this.data[this.date.format('YYYY-MM-DD')]
            let isWeekendActive = false

            if (!data) {
                return []
            } else {
                var weekData = Object.entries(data)

                isWeekendActive = weekData.some(day => {
                    if (moment(day[0]).isoWeekday() === 6 || moment(day[0]).isoWeekday() === 7) {
                        if (day[1].has_data) {
                            return true
                        }
                    }
                })
            }

            if (!isWeekendActive) {
                weekData = weekData.filter(day => {
                    if (moment(day[0]).isoWeekday() !== 6 && moment(day[0]).isoWeekday() !== 7) {
                        return day
                    }
                })
            }

            return weekData
        }
    },
    watch: {
        date() {
            this.fetch()
        }
    },
    mounted() {
        this.fetch()
    },
    methods: {
        async fetch() {
            if (this.data[this.date.format('YYYY-MM-DD')]) {
                return
            }

            this.loading = true

            const data = await axios.get(`/coaches/workload/${this.date.format('YYYY-MM-DD')}`).thenData()

            this.$set(this.data, this.date.format('YYYY-MM-DD'), data)

            this.loading = false
        },
        usage({ available, used }) {
            if (used > 0 && used >= available) {
                return 'red'
            }

            if (available === 0) {
                return ''
            }

            const utilization = (100 * used) / available

            if (utilization <= 49) {
                return 'grey'
            } else if (utilization < 100) {
                return 'orange'
            }
        },
        usageTooltip({ date, slot, available, used }) {
            let text = ''

            if (used > 0 && used >= available) {
                text += lang.get('Occupied slot')
            } else if (available === 0) {
                text += lang.get('Unavailable slot')
            } else {
                text += lang.get('Booked dates: :used <span>of :available</span>', {
                    used: used,
                    available: available
                })
            }

            return text
        },
        calculateTime(slot) {
            const time = 7 * 60 + slot * 15
            let hours = Math.floor(time / 60)
            let minutes = time % 60

            if (hours.toString().length === 1) {
                hours = '0' + hours
            }

            if (minutes.toString().length === 1) {
                minutes += '0'
            }

            const datetime = moment('2020-01-01 ' + hours + ':' + minutes).format('YYYY-MM-DD HH:mm')
            const timeFrom = moment(datetime).subtract(15, 'minutes').format('H:mm')
            const timeTo = moment(datetime).format('H:mm')

            return `${timeFrom} - ${timeTo}`
        }
    }
}
</script>
